// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"zv4mAeXp2WWzpYcrKNCh","button":"BMpoiz2E6nZziiqgqsmk","buttonNew":"EizqlYiYR5t17s2xmFwX","bookDemoButton":"TWsKnTqWUu6R2aSvvsnw","text":"VDnvHbzyYr9mWkRuQqLZ"};